import React from 'react';
import { Switch, Route } from 'react-router';
import { observer } from 'mobx-react';

import UserStore from 'stores/UserStore';
import userGroups from 'enum/userGroups';
import { ENUM_USER_TYPE } from 'enum/profile';

import SmsModal from './SmsModal';


const ignoredPages = [
  '/studio/:user/settings',
  '/:user/settings',
  '/:oauth2/login',
  '/payment/checkout',
  '/page-not-found',
  '/oops',
  '/error-no-profile',
];

const Confirm2FA = () => {
  const { accountType, showTwoFa, twoFaUserData, username } = UserStore.user;

  const { twoFAEnabled } = twoFaUserData || {};
  const isStudionAdmin = accountType === ENUM_USER_TYPE.STUDIO_ADMIN;
  const has2FAEmailCF = UserStore.hasCF(userGroups.TWO_FA_EMAIL_MODAL);

  if (!username || isStudionAdmin || twoFAEnabled || !showTwoFa || has2FAEmailCF) {
    return null;
  }

  return (
    <Switch>
      <Route path={ignoredPages}>
        {null}
      </Route>

      <Route path="*">
        <SmsModal />
      </Route>
    </Switch>
  );
};


export default observer(Confirm2FA);
